import { useContext } from "react";
import AppDataContext from "../context/AppData";

export default () => {
   return useContext(AppDataContext);
};